/**
 * `FormInfoHelpModal` copy for the Site information step (site address + site dimensions).
 */
export const SITE_INFO_STEP_INFO_KEYS = [
  'oppSiteAddress',
  'floorLoad',
  'plenumHeight',
  'raisedFloorStorage',
] as const;
export type SiteInfoStepInfoKey = (typeof SITE_INFO_STEP_INFO_KEYS)[number];

export const SITE_INFO_STEP_FIELD_INFO: Record<
  SiteInfoStepInfoKey,
  { title: string; bullets: readonly string[] }
> = {
  oppSiteAddress: {
    title: 'Site address',
    bullets: [
      'This is repeated here for convenience.',
      'You may have already entered the same value on the opportunity step.',
    ],
  },
  floorLoad: {
    title: 'Weight support of floor (floor load)',
    bullets: [
      'Enter the distributed floor load the raised slab or access floor must support for this space.',
      'Imperial: typically pounds per square foot (lbs/sqft).',
      'Metric: typically kilograms per square meter (kg/m²).',
    ],
  },
  plenumHeight: {
    title: 'Plenum height',
    bullets: [
      'When there is a dropped ceiling, this is the plenum height above the dropped ceiling.',
    ],
  },
  raisedFloorStorage: {
    title: 'Data center flooring (raised floor)',
    bullets: [
      'Yes = raised access floor. No = slab (no access floor) for this area.',
      'The value is stored as Raised or Slab.',
    ],
  },
} as const;

export function siteInfoStepInfoA11y(
  key: SiteInfoStepInfoKey,
): { description: string; hint: string } {
  const p = SITE_INFO_STEP_FIELD_INFO[key];
  return {
    description: `${p.title}. ${p.bullets.join(' ')}`,
    hint: 'Opens help in a dialog.',
  };
}
